import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=1f9c4aea&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=ts"
export * from "./Campaigns.vue?vue&type=script&lang=ts"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=1f9c4aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c4aea",
  null
  
)

export default component.exports